import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import AddMemberToSample from '@components/assign-team-member/AddMemberToSample';
import SampleColorPopUp from '@components/colors/SampleColorPopUp';
import SampleComment from '@components/SampleComment';
import { toastError, toastSuccess } from '@components/Toast';
import TopDetails from '@components/TopDetails';

import RequestTimeline from '@features/sampleDevelopment/components/RequestTimeline';
// import SampleInlineComment from '@features/sampleDevelopment/components/SampleInlineComment';

import { clearCurrentActivePage, setCurrentActivePage } from '@store/actions/ActivePageAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import {
	_getKey,
	changeDateFormat,
	checkSingular,
	getSampleStatus,
	packTag,
	renderSetImages,
	setTag,
	STATIC_SET_CONSTANTS
} from '@utils/Util';

import { SAMPLE_REQUEST_TYPES } from '@/constants/constant';

import SampleRequestModal from '@/features/sampleDevelopment/components/SampleRequestModals/SampleRequestModal';
import AddTaskModal from '@/components/AddTaskModal';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@/store/actions/DesignViewModalAction';

const SingleSampleItem = ({ sampleData, setSampleInfo, fetchSampleDetails }) => {
	// const [activeRemarksId, setActiveRemarksId] = useState(null);
	const [showComment, setShowComment] = useState(false);
	const [designId, setDesignId] = useState(null);
	const [errors, setErrors] = useState([]);
	const [selectedId, setSelectedId] = useState(null);
	const [sample, setSample] = useState(null);
	const [selectedProductIds, setSelectedProductIds] = useState([]);
	// const [isApproveBtnDisabled, setIsApproveBtnDisabled] = useState(false);
	const [showSampleTimelineId, setShowSampleTimelineId] = useState(null);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { id } = useParams();
	const [isShowPDRequestModal, setIsShowPDRequestModal] = useState(false);
	const [isShowBuyerRequestModal, setIsShowBuyerRequestModal] = useState(false);
	const [selectedSampleIds, setSelectedSampleIds] = useState([]);
	const [isShowUpdateTaskModal, setIsShowUpdateTaskModal] = useState(false);

	useEffect(() => {
		if (sample?.approvalStatus === 'APPROVED') {
			navigate(`/sample/view/${sample?.id}`, { replace: true });
		}
	}, [sample?.approvalStatus]);

	useEffect(() => {
		setSample(sampleData);
		return () => {
			dispatch(clearCurrentActivePage());
		};
	}, [sampleData]);

	const getFomattedData = () => {
		let selectedDesignArr = [];
		sample?.sampleRequestItemResponseList?.forEach((item) => {
			if (isProductHasSet(item)) {
				return item?.setMemberSampleRequestItemResponseList.forEach((member) => {
					if (member.id === designId) {
						selectedDesignArr.push(member);
					}
				});
			} else if (item.id === designId) {
				selectedDesignArr.push(item);
			}
		});

		return (
			selectedDesignArr.length &&
			selectedDesignArr[0]?.sampleItemDetailsResponseList.map((itemDetailsId) => {
				return {
					colorDTO: {
						name: itemDetailsId.code,
						colorType: 'SOLID',
						representedBy: 'PANTONE_OR_HEX_CODE',
						compositeColorList: [],
						pantoneColorId: itemDetailsId.pantoneColorId,
						swatchDocumentId: null
					},
					key: itemDetailsId.key,
					colorId: itemDetailsId?.colorResponse?.id,
					itemDetailsId: itemDetailsId?.id,
					quantity: itemDetailsId.quantity || null,
					size: itemDetailsId.size || null
				};
			})
		);
	};

	const isValidAtleastOneRow = (colors) => {
		let isValid = false;
		colors.forEach((item) => {
			if (item.quantity && item.size) {
				isValid = true;
			}
		});
		return isValid;
	};

	const isValidForm = (body) => {
		setErrors([]);
		let isValid = true;
		body.forEach((item) => {
			if (item?.colorDTO?.name && !item.size) {
				setErrors((old) => [
					...old,
					{
						errorKey: item.key,
						type: 'SIZE'
					}
				]);
				isValid = false;
			}
			if (item?.colorDTO?.name && !item.quantity) {
				setErrors((old) => [
					...old,
					{
						errorKey: item.key,
						type: 'QUANTITY'
					}
				]);
				isValid = false;
			}
			if (item.quantity && !item.size) {
				setErrors((old) => [
					...old,
					{
						errorKey: item.key,
						type: 'SIZE'
					}
				]);
				isValid = false;
			}
			if (item.size && !item.quantity) {
				setErrors((old) => [
					...old,
					{
						errorKey: item.key,
						type: 'QUANTITY'
					}
				]);
				isValid = false;
			}
		});
		if (!isValidAtleastOneRow(body)) {
			setErrors((old) => [
				...old,
				{
					errorKey: body[0].key,
					type: 'SIZE'
				}
			]);
			setErrors((old) => [
				...old,
				{
					errorKey: body[0].key,
					type: 'QUANTITY'
				}
			]);
			isValid = false;
		}
		return isValid;
	};

	const onSubmitColorSizeQuantity = async (body) => {
		let quantityList = body?.map((item) => {
			{
				delete item.key;
				return item;
			}
		});
		dispatch(openLoader());
		await ApiClient.PUT('sampleDetailsAction', quantityList, `${sample.id}/items/${designId}`)
			.then(({ data }) => {
				setDesignId(null);
				toastSuccess(data.message);
				fetchSampleDetails();
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	const onAddColorSizeQuantity = (e) => {
		e.stopPropagation();
		let formattedInputs = getFomattedData();
		const isValid = isValidForm(formattedInputs);

		if (!isValid) return;
		onSubmitColorSizeQuantity(formattedInputs);
	};

	// const onApprove = async () => {
	// 	try {
	// 		dispatch(openLoader());
	// 		const { data } = await ApiClient.POST('sampleDetailsAction', {}, `${sample.id}/approve`);

	// 		dispatch(closeLoader());
	// 		if (data) {
	// 			navigate(`/sample/view/${sample.id}`, { replace: true });
	// 		}
	// 	} catch ({ response }) {
	// 		dispatch(closeLoader());
	// 		if (response && response.data && response.data.message) {
	// 			toastError(response.data.message);
	// 		} else {
	// 			toastError('Something went wrong! Please try again.');
	// 		}
	// 	}
	// };

	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack:
					item?.isSet || item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT,
				id: item?.productId,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_LIST'
				// designIdList: designIdList
			})
		);
	};

	// const onCancel = async () => {
	// 	try {
	// 		dispatch(openLoader());
	// 		const { data } = await ApiClient.POST('sampleDetailsAction', {}, `${sample.id}/cancel`);
	// 		dispatch(closeLoader());
	// 		if (data) {
	// 			navigate('/buyer-requests');
	// 		}
	// 	} catch ({ response }) {
	// 		dispatch(closeLoader());
	// 		if (response && response.data && response.data.message) {
	// 			toastError(response.data.message);
	// 		} else {
	// 			toastError('Something went wrong! Please try again.');
	// 		}
	// 	}
	// };

	const onDesignClick = (id) => {
		setDesignId(id);
	};

	const onChangeColorItem = (e, colorItem) => {
		let { name, value } = e.target;
		let updatedDesigns = sample?.sampleRequestItemResponseList;
		updatedDesigns.map((item) => {
			if (isProductHasSet(item)) {
				return item?.setMemberSampleRequestItemResponseList.map((member) => {
					if (member.id === designId) {
						return member.sampleItemDetailsResponseList.map((color) => {
							if (color.key === parseInt(colorItem.key)) {
								if (name === 'code' && !value) {
									color[name] = value;
									color['hexCode'] = null;
									color['pantoneColorId'] = null;
								}
								color[name] = value;
							}
							return color;
						});
					}
				});
			} else {
				if (item.id === designId) {
					item.sampleItemDetailsResponseList.map((color) => {
						if (color.key === parseInt(colorItem.key)) {
							if (name === 'code' && !value) {
								color[name] = value;
								color['hexCode'] = null;
								color['pantoneColorId'] = null;
							}
							color[name] = value;
						}
						return color;
					});
				}
			}
		});
		setSampleInfo({ ...sample, sampleRequestItemResponseList: [...updatedDesigns] });
	};

	const onClickAddNew = (color, key) => {
		let updatedDesigns = sample?.sampleRequestItemResponseList;
		updatedDesigns.map((item) => {
			if (isProductHasSet(item)) {
				item.setMemberSampleRequestItemResponseList.map((member) => {
					if (member?.id === designId) {
						return member.sampleItemDetailsResponseList.map((existingColor) => {
							if (existingColor.key === parseInt(key)) {
								existingColor['code'] = color.code;
								existingColor['hexCode'] = color.hexCode;
								existingColor['pantoneColorId'] = color.pantoneColorId;
							}
							return existingColor;
						});
					}
				});
			} else {
				if (item.id === designId) {
					item.sampleItemDetailsResponseList.map((existingColor) => {
						if (existingColor.key === parseInt(key)) {
							existingColor['code'] = color.code;
							existingColor['hexCode'] = color.hexCode;
							existingColor['pantoneColorId'] = color.pantoneColorId;
						}
						return existingColor;
					});
				}
			}
		});
		setSampleInfo({ ...sample, sampleRequestItemResponseList: [...updatedDesigns] });
	};

	const renderColorAdd = (item) => {
		return (
			<div>
				<SampleColorPopUp
					colorList={item?.sampleItemDetailsResponseList}
					selectedDesignId={designId}
					item={item}
					onCancel={(e) => {
						e.stopPropagation();
						setDesignId(null);
					}}
					onChangeColorItem={onChangeColorItem}
					onClickAddNewItem={onClickAddNew}
					onClickColorSubmit={(e) => {
						onAddColorSizeQuantity(e);
					}}
					errors={errors}
					isShowAddColor={false}
				/>
			</div>
		);
	};

	const onClearChat = () => {
		setSample((prevQuoteStore) => ({
			...prevQuoteStore,
			sampleRequestItemResponseList: prevQuoteStore?.sampleRequestItemResponseList?.map((item) => {
				if (item.productId === selectedId) {
					return {
						...item,
						noOfUnreadMessage: 0
					};
				}
				return item;
			})
		}));

		setSelectedId(null);
	};

	const handleCommentClose = () => {
		dispatch(clearCurrentActivePage());
		setShowComment(false);
		onClearChat();
	};

	const isProductHasSet = (product) => {
		return product.isSet || product.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT;
	};

	const isProductHasPack = (product) => {
		return product.isPack || product.setPackStyleFlag === STATIC_SET_CONSTANTS.PACK_PRODUCT;
	};

	const renderSampleColors = (responseColors = []) => {
		return (
			<div className="sample-details">
				{responseColors.length > 0 &&
					responseColors?.map((size) => (
						<ul key={size.id} className="common-list-component align-items-center mb-2">
							<li className="d-flex align-items-center">
								{size?.colorResponse?.hexCode ? (
									<span
										className="color-icon"
										style={{
											background: size?.colorResponse?.hexCode
										}}
									/>
								) : (
									<span></span>
								)}
								<span className="ml-1">
									{size?.colorResponse?.code || size?.colorResponse?.name}
								</span>
							</li>
							{size.size && size.quantity && (
								<li>
									{size.size} - {checkSingular('PCS', size.quantity)}
								</li>
							)}
						</ul>
					))}
			</div>
		);
	};

	const handleCheckSampleItem = (e, productId, sampleId) => {
		const isChecked = e.target.checked;
		if (isChecked) {
			setSelectedProductIds((prev) => [...prev, productId]);
			if (Array.isArray(sampleId)) {
				setSelectedSampleIds((prev) => [...prev, ...sampleId]);
			} else {
				setSelectedSampleIds((prev) => [...prev, sampleId]);
			}
		} else {
			handleUncheckSampleItem(productId, sampleId);
		}
	};

	const getProductsSampleIds = (item) => {
		const ids = [];
		item?.sampleRequestItemResponseList?.forEach((sample) => {
			if (sample?.isSet || sample?.setPackStyleFlag === 'SET_STYLE') {
				sample?.setMemberSampleRequestItemResponseList?.forEach((member) => {
					ids.push(member?.id);
				});
			} else {
				ids.push(sample?.id);
			}
		});
		return ids;
	};

	const handleUncheckSampleItem = (productId, sampleId) => {
		const updatedItems = selectedProductIds.filter((id) => id !== productId);

		let updatedSampleIds;
		if (Array.isArray(sampleId)) {
			updatedSampleIds = selectedSampleIds.filter((id) => !sampleId.includes(id));
		} else {
			updatedSampleIds = selectedSampleIds.filter((id) => id !== sampleId);
		}

		setSelectedProductIds(updatedItems);
		setSelectedSampleIds(updatedSampleIds);
	};

	const handleCheckAllItem = (e) => {
		const isChecked = e.target.checked;
		if (isChecked) {
			const ids = sample?.sampleRequestItemResponseList?.map((item) => item?.productId);
			const sampleIds = getProductsSampleIds(sample);

			setSelectedSampleIds(sampleIds);
			setSelectedProductIds(ids);
		} else {
			setSelectedProductIds([]);
			setSelectedSampleIds([]);
		}
	};

	const handleBottomPopupAction = (event) => {
		switch (event) {
			case SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE:
				setIsShowPDRequestModal(true);
				break;
			case SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM:
				setIsShowBuyerRequestModal(true);
				break;
			case 'UPDATE_TASK':
				setIsShowUpdateTaskModal(true);
			case 'CLEAR':
				setSelectedProductIds([]);
				break;
			default:
				break;
		}
	};

	return (
		<div>
			<div className="top-header bg-white">
				<div className="filter-container-top pt-2 pb-3 pr-0 bg-gray pl-0">
					<div className="filters">
						<div className="sample-full-status">
							<ul className="common-list-component mb-2">
								<li>
									<img
										src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
										alt="back"
										onClick={() => navigate(-1)}
										className="cursor-pointer"
									/>
									<span className="gray_dark_01">
										{sample?.title || sample?.collectionName}{' '}
									</span>
								</li>

								<li>
									<span className="gray_dark_01">{sample?.refNo} </span>
								</li>
								<li>
									<span className="gray_dark_01">{sample?.requestedBy} </span>
								</li>
								<li>
									<span>
										{changeDateFormat(sample?.requestedDate, 'YYYY-MM-DD', 'Do MMM, YY')}
									</span>
								</li>
								<li>
									<span>{checkSingular('Design', sample?.noOfDesign)} </span>
								</li>
								<li>
									<span className="brand-common-design">{sample?.brand} </span>
								</li>
							</ul>
						</div>
					</div>
					<div className="d-flex align-items-center">
						<AddMemberToSample
							sampleId={sample?.id}
							// toggleBtnDisabled={setIsApproveBtnDisabled}
							requestFrom="PENDING_REQUEST"
						/>

						{/* {sample?.approvalStatus !== 'CANCELLED' && sample?.approvalStatus !== 'APPROVED' && (
							<div className="ml-3">
								<button
									className="button gray-outline size32 mr-3"
									onClick={() => onCancel()}
								>
									<span>Cancel sample request</span>
								</button>
							</div>
						)} */}

						{/* <div className="conversation-button">
							<button className="button text size32" onClick={() => setShowComment(true)}>
								<img src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`} alt="comment" />
							</button>
						</div> */}
					</div>
				</div>
			</div>
			<div className="sample-request-gorup mt-0">
				<div className="sample-details-view-table bg-gray">
					<TopDetails
						type={'SAMPLE'}
						description={sample?.description}
						documentLists={sample?.requestedDocumentList}
					/>
					<div>
						<table className="table with-border scroll-x-label scroll-y-label">
							<thead>
								<tr>
									<th className="select-box-column">
										<div className="custom-chekbox">
											<div className="form-group m-0">
												<input
													id="check_all"
													name="sample check all"
													type="checkbox"
													checked={
														selectedProductIds?.length ===
														sample?.sampleRequestItemResponseList?.length
													}
													onChange={handleCheckAllItem}
												/>
												<label htmlFor="check_all" />
											</div>
										</div>
									</th>
									<th>Design</th>
									<th>Material</th>
									<th className="text-nowrap">Fabric color, size &amp; qty</th>
									<th>Notes</th>
									<th>Status &amp; date</th>
									<th>Conversation</th>
								</tr>
							</thead>
							<tbody>
								{sample?.sampleRequestItemResponseList?.map((item) => (
									<>
										<tr key={item?.productId}>
											<td
												className="select-box-column"
												rowSpan={
													isProductHasSet(item)
														? item?.setMemberSampleRequestItemResponseList.length
														: 1
												}
											>
												<div className="custom-chekbox">
													<div className="form-group m-0">
														<input
															id={`checkbox__${item?.productId}`}
															name={item?.productId}
															type="checkbox"
															checked={selectedProductIds?.includes(
																item?.productId
															)}
															onChange={(e) =>
																handleCheckSampleItem(
																	e,
																	item?.productId,
																	item?.setMemberSampleRequestItemResponseList
																		? item?.setMemberSampleRequestItemResponseList?.map(
																				(member) => member?.id
																			)
																		: item?.id
																)
															}
														/>
														<label htmlFor={`checkbox__${item?.productId}`} />
													</div>
												</div>
											</td>
											<td
												rowSpan={
													isProductHasSet(item)
														? item?.setMemberSampleRequestItemResponseList.length
														: 1
												}
											>
												<div
													className="d-flex cursor-pointer"
													onClick={() => openDesignViewModal(item)}
												>
													<div className="design-image">
														{isProductHasSet(item) ? (
															renderSetImages(
																item?.setMemberSampleRequestItemResponseList,
																'56px'
															)
														) : (
															<img
																src={item?.featureImageDocUrl}
																alt="image"
																className="cell-img pr-2"
															/>
														)}
													</div>
													<div className="d-inline-block align-middle ml-1">
														<div className="mb-1">
															{isProductHasPack(item) && packTag()}
															{isProductHasSet(item) && setTag()}
														</div>
														<span className="text-nowrap">
															{item?.referenceNumber}
														</span>
														<br />
														<ul className="common-list-component my-1">
															{item?.market && <li>{item?.market}</li>}
															{isProductHasSet(item) ? (
																item.setMemberSampleRequestItemResponseList.map(
																	(member) => (
																		<li key={member?.id}>
																			{member?.category}{' '}
																		</li>
																	)
																)
															) : (
																<li>{item?.category} </li>
															)}
														</ul>
														<ul className="common-list-component">
															{isProductHasSet(item) ? (
																<li>
																	{item.setMemberSampleRequestItemResponseList &&
																		item
																			.setMemberSampleRequestItemResponseList[0]
																			?.productCreator}
																</li>
															) : (
																<li>{item?.productCreator}</li>
															)}
															{isProductHasSet(item) ? (
																<li>
																	{changeDateFormat(
																		item.setMemberSampleRequestItemResponseList &&
																			item
																				.setMemberSampleRequestItemResponseList[0]
																				?.productCreationDate,
																		'DD-MM-YYYY',
																		'Do MMM, YY'
																	)}
																</li>
															) : (
																<li>
																	{changeDateFormat(
																		item?.productCreationDate,
																		'DD-MM-YYYY',
																		'Do MMM, YY'
																	)}
																</li>
															)}
														</ul>
														{item?.buyerApprovalStatus === 'CANCELLED' && (
															<div class="task-status red">
																<span class="status-btn ">
																	{item?.buyerApprovalStatus}
																</span>
															</div>
														)}
													</div>
												</div>
											</td>
											<td>
												<ul>
													{isProductHasSet(item) &&
													item?.setMemberSampleRequestItemResponseList &&
													item?.setMemberSampleRequestItemResponseList[0]
														?.materialList
														? item?.setMemberSampleRequestItemResponseList[0]?.materialList.map(
																(material) => (
																	<li key={_getKey()}>{material}</li>
																)
															)
														: item?.materialList &&
															item?.materialList.map((material) => (
																<li key={_getKey()}>{material}</li>
															))}
												</ul>
											</td>
											<td>
												{isProductHasSet(item)
													? designId ===
															item?.setMemberSampleRequestItemResponseList[0]
																?.id &&
														renderColorAdd(
															item?.setMemberSampleRequestItemResponseList[0]
														)
													: designId === item.id && renderColorAdd(item)}
												{isProductHasSet(item)
													? renderSampleColors(
															item?.setMemberSampleRequestItemResponseList[0]
																?.sampleItemDetailsResponseList
														)
													: renderSampleColors(item?.sampleItemDetailsResponseList)}
											</td>
											<td
												rowSpan={
													isProductHasSet(item)
														? item?.setMemberSampleRequestItemResponseList.length
														: 1
												}
											>
												{/* <SampleInlineComment
													sampleRequestId={sample.id || 0}
													id={item.id}
													remarks={item?.remarks}
													activeRemarksId={activeRemarksId}
													onReset={() => {
														setActiveRemarksId(null);
													}}
												/> */}
												<p>{item?.remarks}</p>
											</td>
											<td
												onClick={(e) => {
													e?.stopPropagation();
													setShowSampleTimelineId(item.id);
												}}
												className="cursor-pointer"
											>
												<div
													className={`sample-status-with-details ${
														showSampleTimelineId ? 'timeline-opened' : ''
													}`}
												>
													<div className="sample-status">
														{isProductHasSet(item)
															? getSampleStatus(
																	item
																		?.setMemberSampleRequestItemResponseList[0]
																		?.currentPendingActivity?.activityType
																)
															: getSampleStatus(
																	item?.currentPendingActivity?.activityType
																)}

														{item.basePrice && (
															<p className="costing-amount regular-14">
																${item.basePrice?.toFixed(2)}{' '}
																<span>/unit</span>
															</p>
														)}
														{item?.consumptionResponse &&
															item.consumptionResponse.map((res) => (
																<ul
																	className="common-list-component"
																	key={_getKey()}
																>
																	<li>
																		{res.quantity}
																		{res.quantityUnit}
																	</li>
																</ul>
															))}
													</div>
													<p className="regular-14 weight-300 gray_dark_02">
														{item.requireDate && (
															<>
																<span>RQD</span>
																<span className="gray_dark_02 ml-2">
																	{changeDateFormat(
																		item.requireDate,
																		'YYYY-MM-DD',
																		'Do MMM, YY'
																	)}
																</span>
															</>
														)}
													</p>

													{showSampleTimelineId === item.id && (
														<RequestTimeline
															requireDate={item?.requireDate}
															currentActivity={
																item?.currentPendingActivity?.activityType ||
																null
															}
															activityList={
																isProductHasSet(item)
																	? item
																			?.setMemberSampleRequestItemResponseList[0]
																			?.timeLineActivityResponse
																	: item.timeLineActivityResponse
															}
															onCloseTimeline={(e) => {
																e?.stopPropagation();
																setShowSampleTimelineId(null);
															}}
														/>
													)}
												</div>
											</td>
											<td
												rowSpan={
													isProductHasSet(item)
														? item?.setMemberSampleRequestItemResponseList.length
														: 1
												}
											>
												<div className="conversation-btn">
													<button
														className="button text"
														onClick={() => {
															dispatch(
																setCurrentActivePage({
																	id: item?.productId,
																	type: 'PRODUCT_CONVERSATION',
																	pageType: 'DETAILS'
																})
															);
															setSelectedId(item?.productId);
															setShowComment(true);
														}}
													>
														{item?.noOfUnreadMessage > 0 ? (
															<img
																src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
																alt="not read"
															/>
														) : (
															<img
																src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
																alt="not read"
															/>
														)}
													</button>
												</div>
											</td>
										</tr>
										{isProductHasSet(item) &&
											item?.setMemberSampleRequestItemResponseList &&
											item?.setMemberSampleRequestItemResponseList
												.slice(1)
												.map((member) => (
													<tr key={member?.id}>
														<td>
															{member?.materialList &&
																member.materialList.map((material) => (
																	<p className="mb-1" key={_getKey()}>
																		{material}
																	</p>
																))}
														</td>

														<td onClick={() => onDesignClick(member?.id)}>
															{designId === member?.id &&
																renderColorAdd(member)}
															{renderSampleColors(
																member?.sampleItemDetailsResponseList
															)}
														</td>
														<td
															onClick={(e) => {
																e?.stopPropagation();
																setShowSampleTimelineId(member?.id);
															}}
															className="cursor-pointer"
														>
															<div
																className={`sample-status-with-details ${
																	showSampleTimelineId
																		? 'timeline-opened'
																		: ''
																}`}
															>
																<div className="sample-status">
																	{getSampleStatus(
																		item?.currentPendingActivity
																			?.activityType
																	)}
																	<p className="regular-14 weight-300 gray_dark_02">
																		{item.requireDate && (
																			<>
																				<span>RQD</span>
																				<span className="gray_dark_02 ml-2">
																					{changeDateFormat(
																						item.requireDate,
																						'YYYY-MM-DD',
																						'Do MMM, YY'
																					)}
																				</span>
																			</>
																		)}
																	</p>
																</div>
																{showSampleTimelineId === member?.id && (
																	<RequestTimeline
																		requireDate={member?.requireDate}
																		currentActivity={
																			member?.currentPendingActivity
																				?.activityType || null
																		}
																		activityList={
																			member.timeLineActivityResponse
																		}
																		onCloseTimeline={(e) => {
																			e?.stopPropagation();
																			setShowSampleTimelineId(null);
																		}}
																	/>
																)}
															</div>
														</td>
													</tr>
												))}
									</>
								))}
							</tbody>
						</table>
					</div>
				</div>

				{selectedId && (
					<SampleComment
						sampleRequestId={id}
						postTypeFilter={'PRODUCT_DEVELOPMENT_COMMENT'}
						topic={'PRODUCT_SAMPLE_COMMENT'}
						postTypeId={'sampleRequestId'}
						productId={selectedId}
						showComment={showComment}
						setShowComment={handleCommentClose}
						brandInfo={{
							brandId: sample?.brandId,
							brandName: sample?.brand
						}}
					/>
				)}
				{selectedProductIds?.length > 0 && (
					<div
						className={
							'design-count-section bg-white design-list-count favourite-list-count shadow-8dp'
						}
					>
						<div className="count-info d-flex justify-content-between align-items-center">
							<div className="count-info d-flex justify-content-between align-items-center">
								<div className="design-count">
									<p className="semibold-18">{selectedProductIds?.length}</p>
								</div>

								<span className="regular-16 gray_dark_01 d-inline-block mx-2  selection-devider">
									|
								</span>
								<button
									className="button text size36"
									onClick={() =>
										handleBottomPopupAction(SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE)
									}
								>
									<span className="">Send to PD (In-house Dev.)</span>
								</button>
								<button
									className="button text size36"
									onClick={() =>
										handleBottomPopupAction(
											SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM
										)
									}
								>
									<span className="">H/O to project team for sample dev.</span>
								</button>

								<button
									className="button text size36"
									onClick={() => handleBottomPopupAction('UPDATE_TASK')}
								>
									<span className="">Update task</span>
								</button>
							</div>
							<div
								className="text-right close-icon"
								onClick={() => handleBottomPopupAction('CLEAR')}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="25"
									height="24"
									viewBox="0 0 25 24"
									fill="none"
								>
									<path
										d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
										fill="#6A7181"
									/>
								</svg>
							</div>
						</div>
					</div>
				)}
				{isShowPDRequestModal && (
					<SampleRequestModal
						requestType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
						productIds={selectedProductIds}
						onClose={() => {
							setIsShowPDRequestModal(false);
							setSelectedProductIds([]);
						}}
						taskValueType={SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE}
						title="Send to PD"
						isEdit={true}
						sampleId={selectedSampleIds}
						navigationUrl={`/sample/view/${id}`}
						setSelectedProdutIds={setSelectedProductIds}
					/>
				)}
				{isShowBuyerRequestModal && (
					<SampleRequestModal
						requestType={SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM}
						productIds={selectedProductIds}
						onClose={() => {
							setSelectedProductIds([]);
							setIsShowBuyerRequestModal(false);
						}}
						taskValueType={SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM}
						title="TP handover to project team"
						isEdit={true}
						sampleId={selectedSampleIds}
						navigationUrl={`/sample/view/${id}`}
						setSelectedProdutIds={setSelectedProductIds}
					/>
				)}

				{isShowUpdateTaskModal && (
					<AddTaskModal
						onClose={() => setIsShowUpdateTaskModal(false)}
						productIdList={selectedProductIds}
						onSuccess={() => {
							fetchSampleDetails();
							setIsShowUpdateTaskModal(false);
							setSelectedProductIds([]);
						}}
						params={{ taskValueType: 'CANCEL_BUYER_PLATFORM_SAMPLE_REQUEST' }}
					/>
				)}
			</div>
		</div>
	);
};

export default SingleSampleItem;
